


import { computed, defineComponent } from 'vue'
import bluetooth from "@/services/bluetooth-serial";
import $ from 'jquery';
import { LeanbotSleep } from '../../../public/common/js/api/util';
import { i18n } from '../../app-i18n'; 
import { LEANBOT_SERIAL_BAUD_RATE } from '@/services/defs';
 
export default defineComponent({
  // type inference enabled
//   props: {
//     name: String,
//     msg: { type: String, required: true }
//   },
  data() { 
    return {
      showEmulatorDlg:false,
      emulator:false,
      count:0,
      btnConnectCls:"",
      items:[],
      bluetooth:bluetooth,
      isConnected:false,
      isInited:false,
      showReconnect:false,
      showForceDlg:false,
      connectStatus:false,
      showDlg:computed(()=>this.showForceDlg || this.showReconnect),
      errMsg:"",
      title:"",
      connectBtn: i18n.global.t("message.leanbotoption")
    };
  },
  
  created() {
    // #602: the Leanbot talks at 115200 (see LEANBOT_SERIAL_BAUD_RATE).
    this.bluetooth.setOptions({baudRate:LEANBOT_SERIAL_BAUD_RATE});
    (window as any).bot=this.bluetooth;
    // debugger;
     this.bluetooth.data.subscribe(data=>{
      //  debugger;
       while (this.items.length>10) {
         this.items.shift();
       }
       this.count=this.count+1;
       this.items.push(this.count+":"+JSON.stringify(data));
     })
     this.bluetooth.botState.subscribe((state)=>{
      if (this.isInited) {
        // if (!this.connectStatus) {
          this.showReconnect=!state;
          if (this.showReconnect) {
            this.title="Leanbot disconnected !"
            this.connectStatus=false;
          }
          // console.log(this.showReconnect)
        // }
        
      }
        // this.isConnected=state;
        // console.log(state);
     })
  },

  mounted() {
    if (typeof(conf.emulator)!="undefined") {
      // debugger;
      this.emulator=conf.emulator;
    }
   },
  methods: { 
    
    async startGateway() {
      // this.progress=true;
      
      
    },
    changeBot(){
      this.showForceDlg=true;
      this.bluetooth.selectPort()
      .then(state=>{
        if (state) {
          this.connectBot(true,"Connection Bot ...");
        }
      }).catch(e=>{})
     
     
      // this.connectStatus=true;
    },
    // getReconectText() {
    //   if (this.showReconnect) {
       
    //                return  "The bot had been disconnected !"
                
                    
    //   }
    //   return "Reconnecting bot!";
    // },
    connectVirtualLeanbot(){
      // debugger;
      console.log("connectVirtualLeanbot")
    },
    reconnect() {
      this.showForceDlg=true;
      
      
      this.connectBot(true,"Reconnecting Leanbot ...");
    },
    connectBot(force:boolean=false,title:string) {
      // skip bot state monitor
      this.isInited=false;
      this.errMsg="";
      this.connectStatus=true;
      this.title=title||"Reconnecting Leanbot";
      return Promise.resolve().then(async ()=>{
        await this.bluetooth.disconnect().catch(e=>{});
        await this.bluetooth.reconnect(force).then(async ()=>{
          this.errMsg="";
          
          // wait abit for botstate update
          // await LeanbotSleep(500);
          this.isInited=true;
          this.connectBtn= i18n.global.t("message.change-leanbot")
          // this.connectStatus=false;
          this.showForceDlg=false;
        }).catch((e)=>{
          this.errMsg=e.message;
          this.connectStatus=false;
        });
      })
    
      
      // this.showReconnect=false;
      // new Promise((resolve,reject)=>{
      //   // we only wait 20 sec to connect
      //   setTimeout(()=>{
      //     reject(new Error("Connection timeout"));
      //   },20000)

        
    
     
    },
    connect(){
      console.log("connect")
     
      while (this.items.length) this.items.pop();
      // this.btnConnectCls='hid';
      this.bluetooth.selectPort().then(async (ok)=>{
        // debugger;
        if (ok) {
          this.showForceDlg=true;
          // this.connectStatus=true;
          // this.showForceDlg=true;
          // this.title="Connecting bot ...";
          await this.connectBot(true,"Connecting Leanbot ...");
          // this.btnConnectCls="";
          
          // this.connectStatus=false;
          // this.showForceDlg=false;
         
        }
      })
      // this.bluetooth.selectPortAndConnect().catch().then(()=>{
        
      // });

      
    }
   
  }
}) 
